export default __webpack_public_path__ + "static/media/Lynk&co_Logo_White.682fef24.png";